import Cookies from "js-cookie";
import qs from "qs";

import {
  ICandidateRegion,
  IContestTerritoriesListParams,
  IContestTerritoriesListResponse,
  IContestTerritory,
  IContestTerritoryPayload,
} from "~/entity/ContestTerritories/model/schema";

const API_URL = process.env.REACT_APP_CANDIDATE_API_URL;

const contestTerritoriesServiceMap: Record<string, string> = {
  contestTerritories: "/competitive-territories",
  regions: "/candidate/regions",
};

const getAuthHeaders = (): Record<string, string> => {
  const token = Cookies.get("token");
  if (!token) {
    throw new Error("No token found");
  }
  return { "x-authorization": `Bearer ${token}` };
};

const request = async <T>(path: string, init: RequestInit = {}): Promise<T> => {
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    headers: {
      ...getAuthHeaders(),
      ...(init.body ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return response.json();
};

/** Собирает query string, отбрасывая пустые (undefined/null/'') значения. */
const buildListQuery = (params: IContestTerritoriesListParams = {}): string => {
  const cleaned: Record<string, string | number> = {};
  (Object.keys(params) as (keyof IContestTerritoriesListParams)[]).forEach(
    (key) => {
      const value = params[key];
      if (value === undefined || value === null || value === "") return;
      cleaned[key] = value;
    },
  );
  const query = qs.stringify(cleaned);
  return query ? `?${query}` : "";
};

export class ContestTerritoriesService {
  static GET = {
    getContestTerritories: (
      params: IContestTerritoriesListParams = {},
    ): Promise<IContestTerritoriesListResponse> =>
      request<IContestTerritoriesListResponse>(
        `${contestTerritoriesServiceMap.contestTerritories}${buildListQuery(
          params,
        )}`,
      ),
    getContestTerritory: (id: string): Promise<IContestTerritory> =>
      request<IContestTerritory>(
        `${contestTerritoriesServiceMap.contestTerritories}/${id}`,
      ),
    getRegions: (): Promise<ICandidateRegion[]> =>
      request<ICandidateRegion[]>(contestTerritoriesServiceMap.regions),
  };
  static POST = {
    createContestTerritory: (
      data: IContestTerritoryPayload,
    ): Promise<IContestTerritory> =>
      request<IContestTerritory>(
        contestTerritoriesServiceMap.contestTerritories,
        { method: "POST", body: JSON.stringify(data) },
      ),
  };
  static PATCH = {
    updateContestTerritory: (
      id: string,
      data: IContestTerritoryPayload,
    ): Promise<IContestTerritory> =>
      request<IContestTerritory>(
        `${contestTerritoriesServiceMap.contestTerritories}/${id}`,
        { method: "PATCH", body: JSON.stringify(data) },
      ),
  };
}
